import * as React from 'react';

export function UsersSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}>
      <path d="M7.5 13A4.5 4.5 0 1112 8.5 4.505 4.505 0 017.5 13zm0-7A2.5 2.5 0 1010 8.5 2.5 2.5 0 007.5 6zM15 23v-.5a7.5 7.5 0 00-15 0v.5a1 1 0 002 0v-.5a5.5 5.5 0 0111 0v.5a1 1 0 002 0zm9-5a7 7 0 00-11.667-5.217 1 1 0 101.334 1.49A5 5 0 0122 18a1 1 0 002 0zm-6.5-9A4.5 4.5 0 1122 4.5 4.505 4.505 0 0117.5 9zm0-7A2.5 2.5 0 1020 4.5 2.5 2.5 0 0017.5 2z" />
    </svg>
  );
}
